<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="240" open-on-click left offset-x
      transition="slide-x-transition" origin="center left">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="#008176" dark fab v-bind="attrs" v-on="on">
          <v-icon>fas fa-angle-double-right</v-icon>
        </v-btn>
      </template>

      <v-card style="
        display: flex;
        flex-direction: column;
        overflow: auto;
        border: none;
        height: calc(100vh - 50px);"
        width="300">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title v-if="cliente.nombre">
                {{ cliente.nombre }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ cliente.id_cliente }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-card-actions>
              <v-btn color="#008176" fab dark text @click="none">
                <v-icon>fas fa-angle-double-left</v-icon>
              </v-btn>
            </v-card-actions>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-expansion-panels v-model="panel">
          <OpcionRecursiva :opciones="opciones" @trigger-accion="buscarElementosConObjetosNuevo" />
        </v-expansion-panels>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import OpcionRecursiva from "./OpcionRecursiva.vue";
export default {
  components: {
    OpcionRecursiva,
  },
  props: {
    infocliente: {
      type: Object,
      default: () => ({
        cliente: {},
        campos: [],
        opciones: [],
      }),
    },
  },
  data() {
    return {
      menu: false,
      panel: [],
      objetoParaGrafico: [{}],

      circulos: [],
      poligonos: [],

      cliente: this.infocliente.cliente,
      campos: this.infocliente.campos,
      opciones: this.infocliente.opciones,
      actualizacionArreglos: {
        opciones: {},
        campos: {},
      },
      
      items: this.infocliente.opciones.length,
    };
  },
  created() {
    if (!this.infocliente.opciones || !this.infocliente.campos || !this.infocliente.cliente) {
      this.buscarElementosConObjetosNuevo();
      return;
    }

    // Comprueba si el cliente tiene una opción preferida y la carga si es así
    if (this.cliente.opcion_preferida) {
      this.cargarOpcion(this.cliente.opcion_preferida);
      return;
    }

    // Busca la primera opción que tenga objetos para graficar y la carga
    const opcion_encontrada = this.opciones.find(opcion => "objetos" in opcion.opciones[0]);
    if (opcion_encontrada) {
      this.cargarOpcion(opcion_encontrada.opciones[0].etiqueta);
      return;
    }

    // Si no se encuentra ninguna opción con objetos, carga el mapa normal sin polígonos
    console.log("No se encontró ninguna opción con objetos");
    this.buscarElementosConObjetosNuevo();
  },
  watch: {
    infocliente: {
      handler: function (val, oldVal) {
        if (
          this.infocliente.opciones != null &&
          this.infocliente.campos != null &&
          this.infocliente.cliente != null
        ) {
          this.buscarElementosConObjetosNuevo(
            this.actualizacionArreglos.opciones,
            this.actualizacionArreglos.campos
          );
        }
      },
      deep: true,
    },
  },

  methods: {
    none() {
      this.panel = [];
      this.menu = false;
    },
    /**
     * Busca elementos con objetos nuevos y los actualiza en el mapa
     * @param {Object} opcion - opciones proporcionadas para la actualización de arreglos
     * @param {Object} campo - campos proporcionados para la actualización de arreglos
     */
    buscarElementosConObjetosNuevo(opcion = null, campo = null) {
      if (campo === null) {
        campo = this.campos[0];
      }
      this.actualizacionArreglos.opciones = opcion;
      this.actualizacionArreglos.campos = campo;

      this.objetoParaGrafico = [{}];
      this.circulos = [];
      this.poligonos = [];

      // Crear un objeto arreglos con los elementos necesarios para actualizar los elementos del mapa
      const arreglos = {
        poligonos: this.poligonos,
        circulos: this.circulos,
        centroMapa: this.infocliente.campos[0].centro,
        zoom: this.infocliente.cliente.zoom,
      };

      // Verificar si se proporcionaron opciones y campos
      if (opcion && campo) {

        // Recorrer las opciones y campos en busca de coincidencias
        opcion.objetos.forEach((opcionObj, index) => {
          const temporalObject = campo.objetos.find((elemento) => elemento.id_sig_objeto === opcionObj.id_sig_objeto);

          if (temporalObject) {
            // Copiar el objeto temporal al objeto objetoParaGrafico
            this.objetoParaGrafico[index] = Object.assign({}, temporalObject);
            this.objetoParaGrafico[index].objetoDeOpcion = Object.assign({}, temporalObject.subobjetos[opcionObj.subobjeto_index]);
          } else {
            // Si no hay coincidencia, retornar nulo
            return null;
          }
        });

        // Separar los elementos de acuerdo con su tipo
        this.separarTipoElemento(this.objetoParaGrafico);

        // Si no hay figuras en las matrices circulos o poligonos, enviar solicitud para borrar aplicaciones
        if (!this.buscarFiguraEnStore(this.circulos) && !this.buscarFiguraEnStore(this.poligonos)) {
          this.$store.commit("aplicaciones/borrarAplicaciones");
        }
      }

      this.$store.commit("elementosMapaSig/actualizarElementosMapaSig", arreglos);
    },

    //metodo para separar circulos de los poligos
    separarTipoElemento(elementoEnBruto) {
      elementoEnBruto = JSON.parse(JSON.stringify(elementoEnBruto));
      let indexcirculo = 0;
      let indexpoligono = 0;
      let nuevoCirculo = {};
      let nuevoPoligono = {};
      for (let index = 0; index < elementoEnBruto.length; index++) {
        //validar si hay polígonos
        for (let indexPoligono = 0; indexPoligono < elementoEnBruto[index].poligonos.length; indexPoligono++) {
          const mapId = parseInt(
            `${elementoEnBruto[index].poligonos[indexPoligono].id_poligono}` +
            `${elementoEnBruto[index].id_sig_objeto}`
          );
          if (elementoEnBruto[index].poligonos[indexPoligono].tipo == "Círculo") {
            nuevoCirculo = {
              id: mapId,
              center: elementoEnBruto[index].poligonos[indexPoligono].centro,
              radius: elementoEnBruto[index].poligonos[indexPoligono].radio,
              label: elementoEnBruto[index].objetoDeOpcion.etiqueta,
              aplicacionesCliente: elementoEnBruto[index].aplicaciones,
              color: elementoEnBruto[index].objetoDeOpcion.color,
              nombre_asociado:
                elementoEnBruto[index].objetoDeOpcion.nombre_asociado,
              id_asociado: elementoEnBruto[index].objetoDeOpcion.id_asociado,
              etiqueta: elementoEnBruto[index].objetoDeOpcion.etiqueta,
              fecha: elementoEnBruto[index].objetoDeOpcion.fecha,
              tipo: elementoEnBruto[index].objetoDeOpcion.tipo,
              id_sig_subobjeto:
                elementoEnBruto[index].objetoDeOpcion.id_sig_subobjeto,
            };
            this.circulos.splice(indexcirculo++, 1, nuevoCirculo);
          }

          if (elementoEnBruto[index].poligonos[indexPoligono].tipo == "Polígono") {
            nuevoPoligono = {
              path: elementoEnBruto[index].poligonos[indexPoligono].caminos,
              id: mapId,
              label: elementoEnBruto[index].objetoDeOpcion.etiqueta,
              colorArea: elementoEnBruto[index].objetoDeOpcion.color,
              aplicaciones: elementoEnBruto[index].aplicaciones,
              nombre_asociado:
                elementoEnBruto[index].objetoDeOpcion.nombre_asociado,
              id_asociado: elementoEnBruto[index].objetoDeOpcion.id_asociado,
              etiqueta: elementoEnBruto[index].objetoDeOpcion.etiqueta,
              fecha: elementoEnBruto[index].objetoDeOpcion.fecha,
              tipo: elementoEnBruto[index].objetoDeOpcion.tipo,
              id_sig_subobjeto:
                elementoEnBruto[index].objetoDeOpcion.id_sig_subobjeto,
              color: elementoEnBruto[index].objetoDeOpcion.color,
            };

            this.poligonos.splice(indexpoligono++, 1, nuevoPoligono);
          }
        }

      }
    },

    buscarFiguraEnStore(arreglo) {
      let id =
        this.$store.state.aplicaciones.informacionElemento.id_sig_subobjeto;
      let figuraEnStore = false;
      arreglo.forEach((element) => {
        if (id == element.id_sig_subobjeto) {
          figuraEnStore = true;
        }
      });
      return figuraEnStore;
    },

    /**
      Busca una cadena de texto en un arreglo anidado y devuelve el objeto que contiene esa cadena junto con la información del nivel donde se encuentra.
      @param {string} stringBuscado - La cadena de texto que se desea buscar.
      @param {Array} arreglo - El arreglo donde se va a realizar la búsqueda.
      @param {number} nivel - El nivel actual en el arreglo.
      @param {string} nivelArreglo - El índice de cada nivel del arreglo.
      @returns {object|number} Devuelve un objeto con la información del nivel donde se encuentra la cadena de texto y el objeto que la contiene. Si la cadena no se encuentra, devuelve -1.
    */
    cargarOpcion(opcionPreferida) {
      function buscarString(stringBuscado, arreglo, nivel = 0, nivelArreglo = "") {
        for (let i = 0; i < arreglo.length; i++) {
          const elemento = arreglo[i];
          if (elemento.etiqueta === stringBuscado) {
            return { nivel: nivel, arregloPrincipal: `${nivelArreglo.slice(1).charAt(0)}`, arregloNivel: i, objeto: arreglo[i] };
          }

          const subarreglo = elemento.opciones || elemento.objetos;
          const propiedad = elemento.opciones ? 'opciones' : 'objetos';

          if (subarreglo) {
            const subnivel = buscarString(stringBuscado, subarreglo, nivel + 1, `${nivelArreglo}.${i}.${propiedad}`);
            if ('nivel' in subnivel) {
              return subnivel;
            }
          }
        }
        return {};
      }

      const resultado = buscarString(opcionPreferida, this.opciones);

      // se grafica
      this.buscarElementosConObjetosNuevo(resultado.objeto, this.campos[0]);
    }
  },
};
</script>